import React, { useState } from 'react';
import { translate } from '../../../utils/wp.js';
import { FoodItemFish, FoodItemMeat, FoodItemVeg } from './FoodItem';

function FoodItemList({choices, max, inline, small, disabled, food, onChange}) {
    const [currentVisibleMenu, setCurrentVisibleMenu] = useState(null);
    const canAddMeatTicket = food?.menu?.meat != null;
    const canAddFishTicket = food?.menu?.fish != null;
    const canAddVegTicket = food?.menu?.veg != null;
    const ticketsLeftToAssign = max -
        choices.meat.val -
        choices.fish.val -
        choices.veg.val;
    const numAssignableMeatTickets = max - choices.fish.val - choices.veg.val;
    const numAssignableFishTickets = max - choices.meat.val - choices.veg.val;
    const numAssignableVegTickets = max - choices.meat.val - choices.fish.val;

    function onToggleFoodMenu(value) {
        setCurrentVisibleMenu(currentVisibleMenu !== value ? value : null);
    }

    return (
        <div className="food-item-list flex flex-col gap-2">
            {!disabled && !inline && (
                <div className="tickets-left rounded bg-primary/20 text-black p-2 mb-2 flex justify-between">
                    <div className="p-2 font-bold font-sm">{translate(
                        'food_tickets_left')}
                    </div>
                    <div className="number w-8 h-8 rounded-sm bg-black text-white text-base font-bold flex items-center justify-center">{ticketsLeftToAssign}</div>
                </div>
            )}

            {canAddMeatTicket && (
                <FoodItemMeat
                    disabled={disabled}
                    small={small}
                    expanded={currentVisibleMenu === 0}
                    value={choices.meat.val}
                    min={0}
                    max={numAssignableMeatTickets}
                    menu={food.menu.meat}
                    onToggle={onToggleFoodMenu}
                    onChange={onChange}
                    titles={food.menu.titles}
                />
            )}

            {canAddFishTicket && (
                <FoodItemFish
                    disabled={disabled}
                    small={small}
                    expanded={currentVisibleMenu === 1}
                    value={choices.fish.val}
                    min={0}
                    max={numAssignableFishTickets}
                    menu={food.menu.fish}
                    onToggle={onToggleFoodMenu}
                    onChange={onChange}
                    titles={food.menu.titles}
                />
            )}

            {canAddVegTicket && (
                <FoodItemVeg
                    disabled={disabled}
                    small={small}
                    expanded={currentVisibleMenu === 2}
                    value={choices.veg.val}
                    min={0}
                    max={numAssignableVegTickets}
                    menu={food.menu.veg}
                    onToggle={onToggleFoodMenu}
                    onChange={onChange}
                    titles={food.menu.titles}
                />
            )}
        </div>
    );
}

export { FoodItemList };
